import React from 'react';
import PasswordForm from '../PasswordForm';
import Form2FA from '../Form2FA';
const LoginForm = ({
  signInType = 'default',
  ...props
}) => {
  const signInTypes = {
    'default': () => /*#__PURE__*/React.createElement(PasswordForm, props),
    '2fa': () => /*#__PURE__*/React.createElement(Form2FA, props)
  };
  return signInTypes[signInType] ? signInTypes[signInType]() : null;
};
export default LoginForm;